// extracted by mini-css-extract-plugin
var _1 = "RentalPortalApplicantProfileTabOverview-moduleRentalPortalApplicantProfileTabOverview__XSQVb";
export { _1 as "RentalPortalApplicantProfileTabOverview" }
